import { useMutation } from '@tanstack/react-query';

import { PREFIX_URL } from '@/src/api/config';
import { axios } from '@/src/lib/axios/axios';
import { generateRoutePath } from '@/src/routes';

export type MarkTaskAsCompleteDTOResponse = {
  data: {
    error: string;
    errorDescription: string;
    success: boolean;
    currentTask: any; // Legacy task from task/Details api
  };
  status: boolean;
};

export type markTaskAsCompleteDTO = {
  taskId: number;
};

const url = `${PREFIX_URL}/tasks/:taskId/complete`;

const markTaskAsComplete = ({
  taskId,
}: markTaskAsCompleteDTO): Promise<MarkTaskAsCompleteDTOResponse> => {
  return axios.post(generateRoutePath(url, { taskId }));
};

export const useMarkTaskAsComplete = () => {
  return useMutation({
    mutationFn: ({ taskId }: markTaskAsCompleteDTO) => markTaskAsComplete({ taskId }),
  });
};
